import { CatButton } from '@blocks-react/components/Button';
import { HeaderStoreLocationButtonProps } from './types';
import { FC } from 'react';
import cx from 'classnames';

export const HeaderStoreLocationButton: FC<HeaderStoreLocationButtonProps> = ({
  label,
  onClick,
  isStoreLocationOptimizationFlag = false,
  isMobile = false
}) => {
  return (
    <CatButton
      className={cx('d-flex', {
        'justify-content-end': isStoreLocationOptimizationFlag && isMobile
      })}
      onClick={onClick}
      variant="primary"
      fullWidth={!(isStoreLocationOptimizationFlag && isMobile)}
    >
      {label}
    </CatButton>
  );
};
